import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const ChimneySweep = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my chimney sweep business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps chimney sweep businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for chimney sweep businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most chimney sweep businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my chimney sweep business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like chimney sweep. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Chimney Sweep - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Chimney Sweep CRM", url: "/industries/chimney-sweep" }
  ];

  const industryData = {
    name: 'Chimney Sweep & Repair',
    title: 'Capture Pre-Winter Rush & Build Annual Service Revenue',
    subtitle: 'Never miss seasonal cleaning requests, automate annual reminders, and grow your chimney repair business',
    icon: '🏠',
    challenges: [
      'All calls come in last minute before winter',
      'Customers forget about annual cleanings',
      'Hard to convert cleanings to repairs',
      'Weather affects scheduling',
      'One-time customers never return'
    ],
    solutions: [
      'Pre-season booking automation',
      'Annual cleaning reminder campaigns',
      'Inspection to repair conversion',
      'Weather-based scheduling',
      'Annual service tracking'
    ],
    features: [
      'Customer CRM with chimney details',
      'Annual cleaning reminders',
      'Inspection report automation',
      'Repair estimate tracking',
      'Before/after documentation',
      'Safety certification tracking',
      'Online booking',
      'Review requests'
    ],
    results: [
      '85% annual cleaning retention',
      'Book 3 months in advance',
      '45% cleaning to repair conversion',
      '5.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Chimney Sweep UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for chimney sweep businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for chimney sweep UK, chimney sweep business software, chimney sweep customer management, chimney sweep lead generation UK"
        url="/industries/chimney-sweep"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default ChimneySweep;